import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const HELP_HOME_KEY = 'support.helpHome';
/** The quick issues a ride card can offer (stable codes; the app maps each to its flow and words). */
export const HELP_QUICK_ISSUES = [
    'LOST_ITEM',
    'ROUTE_DEVIATION',
    'DRIVER_DID_NOT_COME',
    'STARTED_WITHOUT_RIDER',
    'ENDED_BEFORE_DESTINATION',
    'NOT_ENDED_AFTER_DROPOFF',
    'DRIVER_CONDUCT',
    'CHARGE',
];
/** The end states of a ride the card is shown for. */
export const HELP_HOME_RIDE_STATUSES = ['completed', 'cancelled', 'no_driver'];
/**
 * The issues that make sense for each end state (a structural bound of the governed value, not a choice): a completed ride may have any; a cancelled one had at
 * most a driver coming (he did not come, started without the rider, behaved badly) and maybe a fee; a ride no driver took has only a charge to ask about.
 */
export const HELP_QUICK_ISSUES_BY_STATUS = {
    completed: HELP_QUICK_ISSUES,
    cancelled: ['DRIVER_DID_NOT_COME', 'STARTED_WITHOUT_RIDER', 'DRIVER_CONDUCT', 'CHARGE'],
    no_driver: ['CHARGE'],
};
export const HELP_HOME_BOUNDS = { lastRideMaxAgeDays: { min: 1, max: 365 } };
export const DEFAULT_HELP_HOME = {
    lastRideMaxAgeDays: 90,
    quickIssues: {
        completed: ['LOST_ITEM', 'ROUTE_DEVIATION', 'DRIVER_DID_NOT_COME', 'STARTED_WITHOUT_RIDER', 'NOT_ENDED_AFTER_DROPOFF', 'CHARGE'],
        cancelled: ['DRIVER_DID_NOT_COME', 'CHARGE'],
        no_driver: [],
    },
};
export const STRICT_HELP_HOME = {
    lastRideMaxAgeDays: HELP_HOME_BOUNDS.lastRideMaxAgeDays.min,
    quickIssues: { completed: [], cancelled: [], no_driver: [] },
};
export const HELP_HOME_POLICY_REASON_CODES = ['HELP_HOME_POLICY_GOVERNED', 'HELP_HOME_POLICY_DEFAULT', 'HELP_HOME_POLICY_INVALID'];
/** The stable issue of a value that is not a `support.helpHome` value, or undefined when it is one. */
export function helpHomeIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, ['lastRideMaxAgeDays', 'quickIssues']))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = HELP_HOME_BOUNDS.lastRideMaxAgeDays;
    if (!intWithin(v.lastRideMaxAgeDays, b.min, b.max))
        return 'INVALID_LAST_RIDE_MAX_AGE_DAYS';
    const q = v.quickIssues;
    if (!isPlainRecord(q) || !hasExactly(q, HELP_HOME_RIDE_STATUSES))
        return 'QUICK_ISSUES_UNKNOWN_OR_MISSING_STATUS';
    for (const status of HELP_HOME_RIDE_STATUSES) {
        const list = q[status];
        if (!Array.isArray(list))
            return 'QUICK_ISSUES_NOT_A_LIST';
        if (list.some((x) => typeof x !== 'string' || !HELP_QUICK_ISSUES.includes(x)))
            return 'UNKNOWN_QUICK_ISSUE';
        if (new Set(list).size !== list.length)
            return 'DUPLICATE_QUICK_ISSUE';
        const allowed = HELP_QUICK_ISSUES_BY_STATUS[status];
        if (list.some((x) => !allowed.includes(x)))
            return 'QUICK_ISSUE_NOT_FOR_STATUS';
    }
    return undefined;
}
export const HELP_HOME_SPEC = {
    key: HELP_HOME_KEY,
    issue: helpHomeIssue,
    copy: (v) => ({
        lastRideMaxAgeDays: v.lastRideMaxAgeDays,
        quickIssues: { completed: [...v.quickIssues.completed], cancelled: [...v.quickIssues.cancelled], no_driver: [...v.quickIssues.no_driver] },
    }),
    defaultValue: DEFAULT_HELP_HOME,
    strictValue: STRICT_HELP_HOME,
    reasonPrefix: 'HELP_HOME_POLICY',
};
export function helpHomeSetting(input) {
    return marketRuleSetting(HELP_HOME_SPEC, input);
}
export function resolveHelpHome(settings, marketId, at, regionCode) {
    return resolveMarketRule(HELP_HOME_SPEC, settings, marketId, at, regionCode);
}
export function helpHomeWire(d) {
    return { ...HELP_HOME_SPEC.copy(d.value), reasonCode: d.reasonCode, policyVersion: d.policyVersion };
}
//# sourceMappingURL=help-home-policy.js.map